import { createSlice } from '@reduxjs/toolkit'

export const configSlice = createSlice({
  name: 'config',
  initialState: {},
  reducers: {
    clearStorage: (state) => {
      localStorage.removeItem('persist:root')
    },
  },
})

export const { clearStorage } = configSlice.actions

export default configSlice.reducer
